import { Component, Input } from '@angular/core'
import { CartItemComponent } from '@spartacus/cart/base/components'

@Component({
    selector: 'app-custom-cart-item-stock',
    templateUrl: './custom-cart-item-stock.component.html',
    styleUrls: ['./custom-cart-item-stock.component.scss'],
    standalone: false
})
export class CustomCartItemStockComponent extends CartItemComponent {
  @Input() showStockStatus = true
}
